import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  LocalizedEnumPipe,
  LocalizedEnumToLookupItemsPipe,
  LocalizedStringPipe,
} from '@em-helpers';
import { FeatureFlagModule } from '@feature-flag';
import {
  GaButtonModule,
  GaCardModule,
  GaIconModule,
  GaModalModule,
  GaSpinnerModule,
  GaTooltipModule,
} from '@vsn-ux/ngx-gaia';

import { NumberInputModule } from '#shared/directives/number-input/number-input.module';

import { CollapsibleAreaComponent } from './components/collapsible-area/collapsible-area.component';
import { FilterCheckboxComponent } from './components/filter-checkbox/filter-checkbox.component';
import { GridBackToEmployeesBtnComponent } from './components/grid-back-to-employees-btn/grid-back-to-employees-btn.component';
import { GridCardDescComponent } from './components/grid-card/components/grid-card-desc.component';
import { GridCardTitleComponent } from './components/grid-card/components/grid-card-title.component';
import { GridCardComponent } from './components/grid-card/grid-card.component';
import { GridErrorRowRendererComponent } from './components/grid-error-row-renderer/grid-error-row-renderer.component';
import { GridHeaderTopComponent } from './components/grid-header-top/grid-header-top.component';
import { GridResultsStatusPanelComponent } from './components/grid-results-status-panel/grid-results-status-panel.component';
import { GridStatusColCellRendererComponent } from './components/grid-status-col-cell-renderer/grid-status-col-cell-renderer.component';
import { GridWarningRowRendererComponent } from './components/grid-warning-row-renderer/grid-warning-row-renderer.component';
import { NavbarModule } from './components/navbar';
import { TagLabelsMoreComponent } from './components/tags/tag-label-more/tag-labels-more.component';
import { WootricDirective } from './directives/wootric.directive';
import { FeatureHighlightDirective } from './modules/feature-highlight/feature-highlight.directive';

@NgModule({
  declarations: [
    WootricDirective,
    FilterCheckboxComponent,
    CollapsibleAreaComponent,
    TagLabelsMoreComponent,
    GridCardComponent,
    GridCardTitleComponent,
    GridCardDescComponent,
    GridBackToEmployeesBtnComponent,
    GridResultsStatusPanelComponent,
    GridStatusColCellRendererComponent,
    GridErrorRowRendererComponent,
    GridWarningRowRendererComponent,
    GridHeaderTopComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FeatureFlagModule,
    LocalizedEnumPipe,
    LocalizedEnumToLookupItemsPipe,
    LocalizedStringPipe,
    GaIconModule,
    GaSpinnerModule,
    GaTooltipModule,
    GaButtonModule,
    GaModalModule,
    GaCardModule,
    FeatureHighlightDirective,
  ],
  exports: [
    WootricDirective,
    FilterCheckboxComponent,
    LocalizedEnumPipe,
    LocalizedEnumToLookupItemsPipe,
    LocalizedStringPipe,
    CollapsibleAreaComponent,
    TagLabelsMoreComponent,
    GridCardComponent,
    GridCardTitleComponent,
    GridCardDescComponent,
    GridStatusColCellRendererComponent,
    NavbarModule,
    GridHeaderTopComponent,
    NumberInputModule,
    FeatureHighlightDirective,
  ],
})
export class SharedModule {}
